// Påminnelselogik: när ett dokument behöver stämmas av på nytt.
// Håller regeln på ett ställe så UI och exporter räknar likadant.

export const addMonths = (iso: string, months: number): Date => {
  const d = new Date(iso);
  d.setMonth(d.getMonth() + months);
  return d;
};

export const daysBetween = (from: Date, to: Date): number =>
  Math.round((to.getTime() - from.getTime()) / 86400000);

export interface ReviewState {
  /** Datum då nästa avstämning ska vara gjord. */
  dueAt: Date | null;
  /** Negativt tal = försenat. */
  daysLeft: number | null;
  overdue: boolean;
  /** Ingen avstämning har gjorts alls. */
  neverReviewed: boolean;
}

/** Återkommande uppföljning i bruksskedet (Dok 33). */
export const usePhaseReviewState = (
  lastReviewedAt: string | null,
  intervalMonths: number,
  createdAt?: string | null
): ReviewState => {
  const base = lastReviewedAt ?? createdAt ?? null;
  if (!base) {
    return { dueAt: null, daysLeft: null, overdue: false, neverReviewed: true };
  }
  const dueAt = addMonths(base, intervalMonths || 12);
  const left = daysBetween(new Date(), dueAt);
  return {
    dueAt,
    daysLeft: left,
    overdue: left < 0,
    neverReviewed: !lastReviewedAt,
  };
};

/** Tredjemansplanen (Dok 07) ska stämmas av när etapper ändras. */
export const thirdPartyNeedsReview = (
  lastStageReviewAt: string | null,
  latestStageChangeAt: string | null
): boolean => {
  if (!latestStageChangeAt) return false;
  if (!lastStageReviewAt) return true;
  return new Date(latestStageChangeAt).getTime() > new Date(lastStageReviewAt).getTime();
};

export const formatDate = (d: Date | string | null): string =>
  d ? new Date(d).toLocaleDateString("sv-SE") : "–";
